/**
 * 画面を移ったあと、新しい画面の見出しへフォーカスを移すための合図。
 * 見出しはデータを読み終えてから出ることがあるので、出たときに見出し（PageHeader）の側で受け取る
 */
let pendingUntil = 0;
const isPending = () => Date.now() < pendingUntil;

export function requestTitleFocus() {
  // 読み込みが長くても、5秒を過ぎたら移さない（あとから急にフォーカスが飛ばないように）
  pendingUntil = Date.now() + 5000;
  // すでに見出しが出ていれば、すぐに移す
  requestAnimationFrame(() => {
    const h = document.querySelector<HTMLElement>("[data-page-title]");
    if (isPending() && h) {
      pendingUntil = 0;
      h.focus({ preventScroll: true });
    }
  });
}

export function takeTitleFocus(el: HTMLElement | null) {
  if (!isPending() || !el) return;
  pendingUntil = 0;
  el.focus({ preventScroll: true });
}

/** ほかの場所にフォーカスを移した（窓を開いたなど）ときは、合図を取り消す */
export function cancelTitleFocus() {
  pendingUntil = 0;
}
